<script>
    import { preventDefault } from "svelte/legacy";

    import { modalState, hideModal } from "@app/store/modalStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import { editorState } from "@app/store/editorStore.svelte.js";
    import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
    import { toast } from "@zerodevx/svelte-toast";
    import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
    import autoFormat from "@cclib/functions/eventGroups/autoFormat.js";
    import autoFormatCheck from "@cclib/functions/eventGroups/autoFormatCheck.js";
    import fixOverlap from "@cclib/functions/eventGroups/fixOverlap.js";
    import * as m from "@app/paraglide/messages.js";
    let maxLines = $state(
            eventGroupState[projectState.selected]
                ? eventGroupState[projectState.selected].maxLines
                : 2,
        ),
        maxChars = $state(
            eventGroupState[projectState.selected]
                ? eventGroupState[projectState.selected].maxChars
                : 32,
        ),
        minDuration = $state(
            eventGroupState[projectState.selected]
                ? eventGroupState[projectState.selected].minDuration
                : 1,
        ),
        allowOrphanWords = $state(false),
        selectiveFormat = $state(true),
        applyAll = $state(true);

    function applyAutoFormat() {
        try {
            if (selectiveFormat && applyAll) {
                eventGroupState[projectState.selected].selected = [];
                eventGroupState[projectState.selected].events.forEach(
                    (evt, index) => {
                        try {
                            if (autoFormatCheck(evt, maxLines, maxChars)) {
                                eventGroupState[
                                    projectState.selected
                                ].selected.push(index);
                            }
                        } catch (err) {
                            console.log(err.message);
                        }
                    },
                );
            } else if (selectiveFormat) {
                let tempSelect = [];
                eventGroupState[projectState.selected].selected.forEach(
                    (evIndex) => {
                        try {
                            if (
                                autoFormatCheck(
                                    eventGroupState[projectState.selected]
                                        .events[evIndex],
                                    maxLines,
                                    maxChars,
                                )
                            ) {
                                tempSelect.push(evIndex);
                            }
                        } catch (err) {
                            console.log(err.message);
                        }
                    },
                );

                eventGroupState[projectState.selected].selected = tempSelect;
            } else if (applyAll) {
                eventGroupState[projectState.selected].selected =
                    eventGroupState[projectState.selected].events.map(
                        (event, count) => {
                            return count;
                        },
                    );
            }

            try {
                eventGroupState[projectState.selected] = autoFormat(
                    eventGroupState[projectState.selected],
                    maxLines,
                    maxChars,
                    minDuration,
                    allowOrphanWords,
                    eventGroupState[projectState.selected].selected,
                );
            } catch (err) {
                console.log(err.message);
            }

            eventGroupState[projectState.selected] = fixOverlap(
                eventGroupState[projectState.selected],
                editorState.minFrameGap,
                projectState.frameRate,
            );

            toast.push(m.auto_format_completed(), {
                classes: ["toast-success"],
            });

            insertHistoryAction({
                name: "auto format", //action name
                eventGroup: projectState.selected,
                snapshots: [
                    {
                        store: "eventGroupState",
                        value: JSON.stringify(eventGroupState),
                    },
                ],
            });
        } catch (err) {
            console.log(err, err.message);
            toast.push(m.auto_format_failed(), {
                classes: ["toast-danger"],
            });
        } finally {
            eventGroupState[projectState.selected].selected = [];
            hideModal();
        }
    }
</script>

<div
    class="modal fade {modalState.selected === 'autoFormat'
        ? 'show d-block'
        : ''}"
    role="dialog"
    tabindex="-1"
    id="AutoFormatModal"
    aria-labelledby="autoFormatTitle"
    aria-describedby="autoFormatDesc"
>
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="autoFormatTitle">
                    {m.auto_format()}
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label={m.close()}
                    onclick={hideModal}
                    id="closeAutoFormat"
                ></button>
            </div>
            <div class="modal-body" id="autoFormatDesc">
                <form
                    onsubmit={preventDefault(applyAutoFormat)}
                    aria-label={m.auto_format_settings()}
                >
                    <div class="mb-3">
                        <label
                            class="form-label"
                            for="maxLinesInput"
                            id="maxLinesLabel">{m.max_lines_per_event()}</label
                        >
                        <input
                            class="form-control"
                            type="number"
                            min="1"
                            max="10"
                            step="1"
                            id="maxLinesInput"
                            bind:value={maxLines}
                            aria-labelledby="maxLinesLabel"
                        />
                    </div>
                    <div class="mb-3">
                        <label
                            class="form-label"
                            for="maxCharsInput"
                            id="maxCharsLabel"
                            >{m.max_characters_per_line()}</label
                        >
                        <input
                            class="form-control"
                            type="number"
                            min="1"
                            max="100"
                            step="1"
                            id="maxCharsInput"
                            bind:value={maxChars}
                            aria-labelledby="maxCharsLabel"
                        />
                    </div>
                    <div class="mb-3">
                        <label
                            class="form-label"
                            for="minDurationInput"
                            id="minDurationLabel"
                            >{m.minimum_duration_seconds()}</label
                        >
                        <input
                            class="form-control"
                            type="number"
                            min="0"
                            max="25"
                            step="0.01"
                            id="minDurationInput"
                            bind:value={minDuration}
                            aria-labelledby="minDurationLabel"
                        />
                    </div>
                    <div class="row mb-3">
                        <div class="col-6">
                            <div class="form-check">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="allowOrphanWordsCheck"
                                    bind:checked={allowOrphanWords}
                                    aria-describedby="orphanWordsDesc"
                                />
                                <label
                                    class="form-check-label"
                                    for="allowOrphanWordsCheck"
                                >
                                    {m.allow_orphan_words()}
                                    <i
                                        class="bi bi-info-circle"
                                        role="img"
                                        aria-label={m.info()}
                                    ></i>
                                </label>
                                <span
                                    id="orphanWordsDesc"
                                    class="visually-hidden"
                                >
                                    {m.allow_orphan_words_help()}
                                </span>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-check">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="smartSelectCheck"
                                    bind:checked={selectiveFormat}
                                    aria-describedby="smartSelectDesc"
                                />
                                <label
                                    class="form-check-label"
                                    for="smartSelectCheck"
                                >
                                    {m.smart_select()}
                                    <i
                                        class="bi bi-info-circle"
                                        role="img"
                                        aria-label={m.info()}
                                    ></i>
                                </label>
                                <span
                                    id="smartSelectDesc"
                                    class="visually-hidden"
                                >
                                    {m.smart_select_help()}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3 form-check">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            id="applyToAll"
                            bind:checked={applyAll}
                            aria-describedby="applyAllDesc"
                        />
                        <label class="form-check-label" for="applyToAll">
                            {m.apply_to_all()}
                            <i
                                class="bi bi-info-circle"
                                role="img"
                                aria-label={m.info()}
                            ></i>
                        </label>
                        <span id="applyAllDesc" class="visually-hidden">
                            {m.apply_to_all_help()}
                        </span>
                    </div>
                    <div class="float-end">
                        <button
                            class="btn btn-primary"
                            id="applyAutoFormatBtn"
                            onclick={applyAutoFormat}
                            type="button"
                            aria-label={m.apply_auto_format()}
                            >{m.auto_format()}</button
                        >
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
